
import React, { useEffect, useState, useMemo,useRef } from "react";
import {
  Box, Typography, IconButton, Container, Avatar,
  TextField, Chip, CircularProgress, Alert,
  Divider, Button, InputAdornment, Badge, Collapse,Pagination
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import ScienceIcon from "@mui/icons-material/Science";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useNavigate } from "react-router-dom";
import CommonFieldsScreen from "./CommonFields";
import DiagnosticSample from "../Logos/DiagnoisticDelivery/DiagnosticSampleCollection.png";
import Footer from "../Common/Footer";
import { apiRequest } from "../../fetchSetup";
import { fetchUserFromRedis } from "../HomePage/AuthonticationScreens/Register";
import PackageCard from "../Cards/PackageCard";
import  bg2 from "../Logos/med_background2.png"
import { ChevronLeft, Edit2, Tag, ChevronDown, ChevronUp, Plus, Minus, Trash2, X } from 'lucide-react';
import axios from 'axios';
import CustomDialog from "../../CustomDialog";



const DIAGNOSTIC_TESTS_API = process.env.REACT_APP_GET_DIAGNOSTIC_TESTS;

const BASE_URL = process.env.REACT_APP_BASE_TESTS;
const C = {
  primary: "#006D77",
  primaryDark: "#004F55",
  primaryLight: "#E0F7FA",
  bg: "#F7FAFA",
  border: "#EEEEEE",
  text: "#1a1a1a",
  muted: "#999",
  error: "#EF5350",
  success: "#2E7D32",
  successLight: "#E8F5E9",
};


// ─── CATEGORY META ────────────────────────────────────────────────────────────
const CATEGORY_META = {
  "health packages":    { color: "#EFF8EF", border: "#4CAF50", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="8" y="16" width="48" height="36" rx="4" fill="#E8F5E9" stroke="#4CAF50" stroke-width="2.5"/><path d="M26 34h12M32 28v12" stroke="#4CAF50" stroke-width="3" stroke-linecap="round"/><path d="M8 24h48" stroke="#4CAF50" stroke-width="2"/><rect x="22" y="10" width="20" height="10" rx="2" fill="#4CAF50" opacity="0.3" stroke="#4CAF50" stroke-width="2"/></svg>` },
  "anaemia":            { color: "#FFF0F0", border: "#EF5350", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="20" fill="#FFCDD2" stroke="#EF5350" stroke-width="2.5"/><path d="M32 20C36 26 42 30 36 38C32 44 26 40 24 34C22 28 28 22 32 20Z" fill="#EF5350" opacity="0.7"/><circle cx="32" cy="32" r="4" fill="#EF5350"/></svg>` },
  "diabetes":           { color: "#FFF7EE", border: "#FF9800", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="24" y="8" width="8" height="28" rx="4" fill="#FFE0B2" stroke="#FF9800" stroke-width="2.5"/><circle cx="28" cy="44" r="8" fill="#FF9800" opacity="0.2" stroke="#FF9800" stroke-width="2.5"/><path d="M40 20L52 20M52 44L40 44M52 20L52 44" stroke="#FF9800" stroke-width="2.5" stroke-linecap="round"/></svg>` },
  "heart":              { color: "#FEF0F4", border: "#E91E63", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32 52C32 52 10 38 10 24C10 17 16 12 22 12C26 12 30 14 32 18C34 14 38 12 42 12C48 12 54 17 54 24C54 38 32 52 32 52Z" fill="#F48FB1" stroke="#E91E63" stroke-width="2.5"/><path d="M18 30L24 24L28 32L34 20L38 28L44 28" stroke="#E91E63" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>` },
  "liver":              { color: "#FFFBEE", border: "#FFC107", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 20C10 28 12 36 14 44C22 50 32 50 42 50C52 44 52 34 52 24C44 16 28 16 36 16C28 16 22 18 14 20Z" fill="#FFE082" stroke="#FFC107" stroke-width="2.5"/><path d="M24 30C28 26 36 28 38 34" stroke="#FFC107" stroke-width="2" stroke-linecap="round"/></svg>` },
  "lungs":              { color: "#EEF6FF", border: "#2196F3", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32 12L32 40" stroke="#2196F3" stroke-width="3" stroke-linecap="round"/><path d="M32 20C22 20 12 26 12 38C12 46 18 52 26 50C30 49 32 44 32 40" fill="#BBDEFB" stroke="#2196F3" stroke-width="2.5"/><path d="M32 20C42 20 52 26 52 38C52 46 46 52 38 50C34 49 32 44 32 40" fill="#BBDEFB" stroke="#2196F3" stroke-width="2.5"/></svg>` },
  "fertility":          { color: "#F9F0FF", border: "#9C27B0", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="28" r="14" fill="#E1BEE7" stroke="#9C27B0" stroke-width="2.5"/><path d="M32 42L32 56" stroke="#9C27B0" stroke-width="2.5" stroke-linecap="round"/><path d="M26 50L32 56L38 50" stroke="#9C27B0" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/><circle cx="32" cy="28" r="6" fill="#9C27B0" opacity="0.4"/></svg>` },
  "kidney":             { color: "#EEF0FF", border: "#3F51B5", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 16C12 20 10 32 14 42C18 52 28 54 34 48C38 44 36 38 34 34C32 30 34 24 32 20C30 14 24 14 20 16Z" fill="#C5CAE9" stroke="#3F51B5" stroke-width="2.5"/><path d="M44 16C52 20 54 32 50 42C46 52 36 54 30 48C26 44 28 38 30 34C32 30 30 24 32 20C34 14 40 14 44 16Z" fill="#C5CAE9" stroke="#3F51B5" stroke-width="2.5"/></svg>` },
  "allergy":            { color: "#F3FAF0", border: "#8BC34A", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="16" fill="#DCEDC8" stroke="#8BC34A" stroke-width="2.5"/><path d="M32 16L32 48M16 32L48 32M20 20L44 44M44 20L20 44" stroke="#8BC34A" stroke-width="1.5" stroke-linecap="round" opacity="0.5"/><circle cx="32" cy="32" r="6" fill="#8BC34A" opacity="0.6"/></svg>` },
  "thyroid":            { color: "#E8FDFF", border: "#00BCD4", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22 16C16 20 14 30 18 38C20 42 24 44 28 44L32 44L36 44C40 44 44 42 46 38C50 30 48 20 42 16C38 12 26 12 22 16Z" fill="#B2EBF2" stroke="#00BCD4" stroke-width="2.5"/><circle cx="26" cy="30" r="5" fill="#00BCD4" opacity="0.5"/><circle cx="38" cy="30" r="5" fill="#00BCD4" opacity="0.5"/></svg>` },
  "vitamins":           { color: "#FFFDE7", border: "#F9A825", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="20" y="20" width="24" height="30" rx="6" fill="#FFF176" stroke="#F9A825" stroke-width="2.5"/><rect x="24" y="12" width="16" height="12" rx="4" fill="#F9A825" opacity="0.4" stroke="#F9A825" stroke-width="2"/><path d="M26 32L30 36L38 28" stroke="#F9A825" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>` },
  "fever":              { color: "#FFF0EE", border: "#F44336", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="28" y="8" width="8" height="34" rx="4" fill="#FFCDD2" stroke="#F44336" stroke-width="2.5"/><circle cx="32" cy="48" r="8" fill="#F44336" opacity="0.8" stroke="#F44336" stroke-width="2"/><path d="M36 16L40 12M36 24L42 22M36 32L40 34" stroke="#F44336" stroke-width="2" stroke-linecap="round" opacity="0.6"/></svg>` },
  "bone":               { color: "#F7F7F7", border: "#9E9E9E", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 14C16 14 12 18 14 22C15 24 18 24 18 26L18 38C18 40 15 40 14 42C12 46 16 50 20 50C22 50 24 48 24 46C24 44 22 42 24 40L40 40C42 42 40 44 40 46C40 48 42 50 44 50C48 50 52 46 50 42C49 40 46 40 46 38L46 26C46 24 49 24 50 22C52 18 48 14 44 14C42 14 40 16 40 18C40 20 42 22 40 24L24 24C22 22 24 20 24 18C24 16 22 14 20 14Z" fill="#E0E0E0" stroke="#9E9E9E" stroke-width="2"/></svg>` },
  "immunity":           { color: "#EFF8EF", border: "#43A047", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32 8L50 16L50 34C50 44 42 52 32 56C22 52 14 44 14 34L14 16Z" fill="#C8E6C9" stroke="#43A047" stroke-width="2.5"/><path d="M24 32L29 37L40 26" stroke="#43A047" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>` },
  "cancer":             { color: "#FEF0F4", border: "#E91E63", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="10" fill="#F48FB1" stroke="#E91E63" stroke-width="2.5"/><path d="M32 10L32 18M32 46L32 54M10 32L18 32M46 32L54 32M16 16L22 22M42 42L48 48M48 16L42 22M22 42L16 48" stroke="#E91E63" stroke-width="2.5" stroke-linecap="round" opacity="0.7"/></svg>` },
  "hormones":           { color: "#F3EEFF", border: "#673AB7", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 48C20 48 16 36 24 28C28 24 34 24 38 20C44 14 44 8 44 8" stroke="#673AB7" stroke-width="2.5" stroke-linecap="round"/><circle cx="44" cy="8" r="4" fill="#673AB7" opacity="0.6"/><path d="M44 48C44 48 48 36 40 28C36 24 30 24 26 20C20 14 20 8 20 8" stroke="#9C27B0" stroke-width="2.5" stroke-linecap="round" opacity="0.5"/><circle cx="32" cy="36" r="6" fill="#EDE7F6" stroke="#673AB7" stroke-width="2"/></svg>` },
  "prostate":           { color: "#EEF0FF", border: "#3F51B5", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="28" r="16" fill="#C5CAE9" stroke="#3F51B5" stroke-width="2.5"/><circle cx="32" cy="28" r="8" fill="#3F51B5" opacity="0.3"/><path d="M28 44L28 56M36 44L36 56" stroke="#3F51B5" stroke-width="2.5" stroke-linecap="round"/></svg>` },
  "pregnancy":          { color: "#F9F0FF", border: "#AB47BC", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="14" r="8" fill="#E1BEE7" stroke="#AB47BC" stroke-width="2.5"/><path d="M20 26C16 28 16 36 16 36C16 44 22 52 32 54C42 52 48 44 48 36C48 28 44 26 44 26C40 24 36 24 32 24C28 24 24 24 20 26Z" fill="#E1BEE7" stroke="#AB47BC" stroke-width="2.5"/><circle cx="32" cy="38" r="6" fill="#AB47BC" opacity="0.3"/></svg>` },
  "hiv":                { color: "#E8FFFD", border: "#009688", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="20" fill="#B2DFDB" stroke="#009688" stroke-width="2.5"/><path d="M22 22L42 42M42 22L22 42" stroke="#009688" stroke-width="3" stroke-linecap="round"/><circle cx="32" cy="32" r="6" fill="#009688" opacity="0.4"/></svg>` },
  "tuberculosis":       { color: "#EEF6FF", border: "#42A5F5", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32 12L32 40" stroke="#42A5F5" stroke-width="3" stroke-linecap="round"/><path d="M32 18C24 18 16 24 16 34C16 42 22 48 30 48" fill="#BBDEFB" stroke="#42A5F5" stroke-width="2.5"/><path d="M32 18C40 18 48 24 48 34C48 42 42 48 34 48" fill="#BBDEFB" stroke="#42A5F5" stroke-width="2.5"/><circle cx="24" cy="34" r="4" fill="#42A5F5" opacity="0.5"/><circle cx="40" cy="34" r="4" fill="#42A5F5" opacity="0.5"/></svg>` },
  "other pathology tests": { color: "#F5FBE7", border: "#9CCC65", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="24" y="8" width="10" height="30" rx="5" fill="#DCEDC8" stroke="#9CCC65" stroke-width="2.5"/><ellipse cx="29" cy="44" rx="10" ry="6" fill="#9CCC65" opacity="0.4" stroke="#9CCC65" stroke-width="2"/><circle cx="42" cy="20" r="8" fill="#F9FBE7" stroke="#9CCC65" stroke-width="2"/><circle cx="42" cy="20" r="3" fill="#9CCC65" opacity="0.6"/></svg>` },
  "musculo skeletal disorders": { color: "#ECEFF1", border: "#607D8B", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 10L20 30C20 36 26 40 32 40C38 40 44 36 44 30L44 10" stroke="#607D8B" stroke-width="2.5" stroke-linecap="round"/><path d="M16 30C16 40 24 48 32 54C40 48 48 40 48 30" fill="#CFD8DC" stroke="#607D8B" stroke-width="2"/><circle cx="20" cy="10" r="4" fill="#607D8B" opacity="0.5"/><circle cx="44" cy="10" r="4" fill="#607D8B" opacity="0.5"/></svg>` },
  "toxicology":         { color: "#FFFBEE", border: "#FF8F00", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26 10L26 26L16 42C14 46 16 52 22 52L42 52C48 52 50 46 48 42L38 26L38 10Z" fill="#FFE082" stroke="#FF8F00" stroke-width="2.5"/><path d="M24 10L40 10" stroke="#FF8F00" stroke-width="2.5" stroke-linecap="round"/><circle cx="32" cy="40" r="5" fill="#FF8F00" opacity="0.6"/></svg>` },
  "clotting disorders": { color: "#FFF0F0", border: "#EF9A9A", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32 10C32 10 20 22 20 34C20 44 26 52 32 52C38 52 44 44 44 34C44 22 32 10 32 10Z" fill="#FFCDD2" stroke="#E53935" stroke-width="2.5"/><path d="M26 36C28 40 36 40 38 36" stroke="#E53935" stroke-width="2" stroke-linecap="round"/></svg>` },
  "drug level monitoring": { color: "#EEF0FF", border: "#5C6BC0", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="22" y="18" width="20" height="30" rx="4" fill="#C5CAE9" stroke="#5C6BC0" stroke-width="2.5"/><rect x="26" y="10" width="12" height="10" rx="3" fill="#5C6BC0" opacity="0.4" stroke="#5C6BC0" stroke-width="2"/><path d="M28 30L36 30M28 36L34 36" stroke="#5C6BC0" stroke-width="2" stroke-linecap="round"/></svg>` },
  "heavy metals":       { color: "#ECEFF1", border: "#78909C", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="22" cy="36" r="10" fill="#CFD8DC" stroke="#546E7A" stroke-width="2.5"/><circle cx="42" cy="36" r="10" fill="#B0BEC5" stroke="#546E7A" stroke-width="2.5"/><circle cx="32" cy="26" r="10" fill="#90A4AE" stroke="#546E7A" stroke-width="2.5"/></svg>` },
  "infectious disease": { color: "#EFF8EF", border: "#66BB6A", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="12" fill="#C8E6C9" stroke="#388E3C" stroke-width="2.5"/><circle cx="32" cy="32" r="5" fill="#388E3C" opacity="0.5"/><path d="M32 10L32 16M32 48L32 54M10 32L16 32M48 32L54 32M16 16L20 20M44 44L48 48M48 16L44 20M20 44L16 48" stroke="#388E3C" stroke-width="2" stroke-linecap="round"/></svg>` },
  "blood disorders":    { color: "#FFF0F0", border: "#EF5350", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32 8C32 8 14 24 14 38C14 48 22 56 32 56C42 56 50 48 50 38C50 24 32 8 32 8Z" fill="#FFCDD2" stroke="#C62828" stroke-width="2.5"/><path d="M22 38C22 44 26 48 32 48" stroke="#C62828" stroke-width="2" stroke-linecap="round"/></svg>` },
  "autoimmune disorders": { color: "#F9F0FF", border: "#AB47BC", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse cx="32" cy="28" rx="18" ry="14" fill="#E1BEE7" stroke="#7B1FA2" stroke-width="2.5"/><path d="M20 34C22 42 42 42 44 34" fill="#CE93D8" stroke="#7B1FA2" stroke-width="2"/><circle cx="24" cy="24" r="3" fill="#7B1FA2" opacity="0.5"/><circle cx="40" cy="24" r="3" fill="#7B1FA2" opacity="0.5"/></svg>` },
  "stomach":            { color: "#FFF7EE", border: "#FFA726", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 20C12 24 12 38 18 44C24 50 40 50 46 44C52 38 52 26 46 20C40 14 24 16 18 20Z" fill="#FFE0B2" stroke="#E65100" stroke-width="2.5"/><path d="M22 30C26 26 38 28 42 34" stroke="#E65100" stroke-width="2" stroke-linecap="round"/></svg>` },
  "inflammatory markers": { color: "#FFF0EE", border: "#FF7043", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32 8L38 22L54 22L42 32L46 48L32 38L18 48L22 32L10 22L26 22Z" fill="#FFCCBC" stroke="#BF360C" stroke-width="2.5"/><circle cx="32" cy="28" r="6" fill="#FF7043" opacity="0.6"/></svg>` },
  "electrolytes":       { color: "#FFFDE7", border: "#FFD54F", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M36 8L24 34L32 34L28 56L44 28L36 28Z" fill="#FFF176" stroke="#F57F17" stroke-width="2.5"/><circle cx="18" cy="22" r="5" fill="#FFD54F" stroke="#F57F17" stroke-width="2"/><circle cx="46" cy="44" r="5" fill="#FFD54F" stroke="#F57F17" stroke-width="2"/></svg>` },
};
// Additional meta for profile/panel types from real DB data
const EXTRA_META = {
  // surgical / major / minor surgical
  "surgical":    { color: "#E8F5E9", border: "#43A047", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 14L50 50M14 50L50 14" stroke="#43A047" stroke-width="3" stroke-linecap="round" opacity="0.3"/><path d="M20 20L44 44" stroke="#43A047" stroke-width="4" stroke-linecap="round"/><circle cx="20" cy="20" r="5" fill="#43A047" opacity="0.7"/><rect x="40" y="38" width="12" height="6" rx="2" fill="#43A047" opacity="0.5" transform="rotate(45 40 38)"/></svg>` },
  // lipid / cholesterol / cardiac
  "lipid":       { color: "#FEF0F4", border: "#E91E63", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32 52C32 52 10 38 10 24C10 17 16 12 22 12C26 12 30 14 32 18C34 14 38 12 42 12C48 12 54 17 54 24C54 38 32 52 32 52Z" fill="#F48FB1" stroke="#E91E63" stroke-width="2.5"/><path d="M18 30L24 24L28 32L34 20L38 28L44 28" stroke="#E91E63" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>` },
  // torch / viral / infection / panel
  "torch":       { color: "#EFF8EF", border: "#66BB6A", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="12" fill="#C8E6C9" stroke="#388E3C" stroke-width="2.5"/><circle cx="32" cy="32" r="5" fill="#388E3C" opacity="0.5"/><path d="M32 10L32 16M32 48L32 54M10 32L16 32M48 32L54 32M16 16L20 20M44 44L48 48M48 16L44 20M20 44L16 48" stroke="#388E3C" stroke-width="2" stroke-linecap="round"/></svg>` },
  // coagulation / clotting / bleeding / pt / aptt
  "coagul":      { color: "#FFF0F0", border: "#EF9A9A", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32 10C32 10 20 22 20 34C20 44 26 52 32 52C38 52 44 44 44 34C44 22 32 10 32 10Z" fill="#FFCDD2" stroke="#E53935" stroke-width="2.5"/><path d="M26 36C28 40 36 40 38 36" stroke="#E53935" stroke-width="2" stroke-linecap="round"/></svg>` },
  // ante natal / prenatal / obstetric / antenatal
  "natal":       { color: "#F9F0FF", border: "#AB47BC", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="14" r="8" fill="#E1BEE7" stroke="#AB47BC" stroke-width="2.5"/><path d="M20 26C16 28 16 36 16 36C16 44 22 52 32 54C42 52 48 44 48 36C48 28 44 26 44 26C40 24 36 24 32 24C28 24 24 24 20 26Z" fill="#E1BEE7" stroke="#AB47BC" stroke-width="2.5"/><circle cx="32" cy="38" r="6" fill="#AB47BC" opacity="0.3"/></svg>` },
  // viral / virus
  "viral":       { color: "#EFF8EF", border: "#66BB6A", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="12" fill="#C8E6C9" stroke="#388E3C" stroke-width="2.5"/><circle cx="32" cy="32" r="5" fill="#388E3C" opacity="0.5"/><path d="M32 10L32 16M32 48L32 54M10 32L16 32M48 32L54 32M16 16L20 20M44 44L48 48M48 16L44 20M20 44L16 48" stroke="#388E3C" stroke-width="2" stroke-linecap="round"/></svg>` },
  // renal / kidney / creatinine / urea
  "renal":       { color: "#EEF0FF", border: "#3F51B5", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 16C12 20 10 32 14 42C18 52 28 54 34 48C38 44 36 38 34 34C32 30 34 24 32 20C30 14 24 14 20 16Z" fill="#C5CAE9" stroke="#3F51B5" stroke-width="2.5"/><path d="M44 16C52 20 54 32 50 42C46 52 36 54 30 48C26 44 28 38 30 34C32 30 30 24 32 20C34 14 40 14 44 16Z" fill="#C5CAE9" stroke="#3F51B5" stroke-width="2.5"/></svg>` },
  // liver / hepatic / lft / bilirubin
  "hepat":       { color: "#FFFBEE", border: "#FFC107", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 20C10 28 12 36 14 44C22 50 32 50 42 50C52 44 52 34 52 24C44 16 28 16 36 16C28 16 22 18 14 20Z" fill="#FFE082" stroke="#FFC107" stroke-width="2.5"/><path d="M24 30C28 26 36 28 38 34" stroke="#FFC107" stroke-width="2" stroke-linecap="round"/></svg>` },
  // complete blood / cbc / haemogram / blood count
  "blood":       { color: "#FFF0F0", border: "#EF5350", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M32 8C32 8 14 24 14 38C14 48 22 56 32 56C42 56 50 48 50 38C50 24 32 8 32 8Z" fill="#FFCDD2" stroke="#C62828" stroke-width="2.5"/><path d="M22 38C22 44 26 48 32 48" stroke="#C62828" stroke-width="2" stroke-linecap="round"/></svg>` },
  // urine / urinalysis
  "urin":        { color: "#FFFDE7", border: "#F9A825", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26 10C26 10 18 28 18 40C18 50 24 56 32 56C40 56 46 50 46 40C46 28 38 10 38 10Z" fill="#FFF9C4" stroke="#F9A825" stroke-width="2.5"/><circle cx="32" cy="42" r="6" fill="#F9A825" opacity="0.4"/></svg>` },
  // hormone / endocrine / pituitary
  "hormon":      { color: "#F3EEFF", border: "#673AB7", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 48C20 48 16 36 24 28C28 24 34 24 38 20C44 14 44 8 44 8" stroke="#673AB7" stroke-width="2.5" stroke-linecap="round"/><circle cx="44" cy="8" r="4" fill="#673AB7" opacity="0.6"/><path d="M44 48C44 48 48 36 40 28C36 24 30 24 26 20C20 14 20 8 20 8" stroke="#9C27B0" stroke-width="2.5" stroke-linecap="round" opacity="0.5"/></svg>` },
  // bone / calcium / mineral / density
  "bone":        { color: "#F7F7F7", border: "#9E9E9E", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 14C16 14 12 18 14 22C15 24 18 24 18 26L18 38C18 40 15 40 14 42C12 46 16 50 20 50C22 50 24 48 24 46C24 44 22 42 24 40L40 40C42 42 40 44 40 46C40 48 42 50 44 50C48 50 52 46 50 42C49 40 46 40 46 38L46 26C46 24 49 24 50 22C52 18 48 14 44 14C42 14 40 16 40 18C40 20 42 22 40 24L24 24C22 22 24 20 24 18C24 16 22 14 20 14Z" fill="#E0E0E0" stroke="#9E9E9E" stroke-width="2"/></svg>` },
  // fever / typhoid / malaria / dengue / widal
  "fever":       { color: "#FFF0EE", border: "#F44336", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="28" y="8" width="8" height="34" rx="4" fill="#FFCDD2" stroke="#F44336" stroke-width="2.5"/><circle cx="32" cy="48" r="8" fill="#F44336" opacity="0.8" stroke="#F44336" stroke-width="2"/></svg>` },
  // stool / faecal
  "stool":       { color: "#FFF7EE", border: "#FF9800", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse cx="32" cy="44" rx="18" ry="10" fill="#FFE0B2" stroke="#FF9800" stroke-width="2.5"/><path d="M24 44C22 36 26 28 32 26C38 28 42 36 40 44" fill="#FFCC80" stroke="#FF9800" stroke-width="2"/><circle cx="32" cy="24" r="6" fill="#FFE0B2" stroke="#FF9800" stroke-width="2"/></svg>` },
  // semen / sperm / male fertility
  "semen":       { color: "#E8FDFF", border: "#00BCD4", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="36" r="12" fill="#B2EBF2" stroke="#00BCD4" stroke-width="2.5"/><path d="M32 24L32 10M26 16L32 10L38 16" stroke="#00BCD4" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>` },
  // culture / sensitivity / microbiology
  "cultur":      { color: "#F3FAF0", border: "#8BC34A", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="18" fill="#DCEDC8" stroke="#8BC34A" stroke-width="2.5"/><circle cx="26" cy="28" r="4" fill="#8BC34A" opacity="0.5"/><circle cx="38" cy="28" r="4" fill="#8BC34A" opacity="0.5"/><circle cx="32" cy="38" r="4" fill="#8BC34A" opacity="0.5"/><circle cx="32" cy="32" r="2" fill="#8BC34A" opacity="0.8"/></svg>` },
  // iron / ferritin / thalassemia
  "iron":        { color: "#FFF0F0", border: "#EF5350", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="20" fill="#FFCDD2" stroke="#EF5350" stroke-width="2.5"/><path d="M32 20C36 26 42 30 36 38C32 44 26 40 24 34C22 28 28 22 32 20Z" fill="#EF5350" opacity="0.7"/></svg>` },
  // electrolyte / sodium / potassium
  "electro":     { color: "#FFFDE7", border: "#FFD54F", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M36 8L24 34L32 34L28 56L44 28L36 28Z" fill="#FFF176" stroke="#F57F17" stroke-width="2.5"/></svg>` },
  // allergy / skin prick
  "allerg":      { color: "#F3FAF0", border: "#8BC34A", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32" r="16" fill="#DCEDC8" stroke="#8BC34A" stroke-width="2.5"/><path d="M32 16L32 48M16 32L48 32M20 20L44 44M44 20L20 44" stroke="#8BC34A" stroke-width="1.5" stroke-linecap="round" opacity="0.5"/><circle cx="32" cy="32" r="6" fill="#8BC34A" opacity="0.6"/></svg>` },
  // comprehensive / complete / full body
  "compreh":     { color: "#EFF8EF", border: "#4CAF50", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="8" y="16" width="48" height="36" rx="4" fill="#E8F5E9" stroke="#4CAF50" stroke-width="2.5"/><path d="M26 34h12M32 28v12" stroke="#4CAF50" stroke-width="3" stroke-linecap="round"/><path d="M8 24h48" stroke="#4CAF50" stroke-width="2"/><rect x="22" y="10" width="20" height="10" rx="2" fill="#4CAF50" opacity="0.3" stroke="#4CAF50" stroke-width="2"/></svg>` },
};

const DEFAULT_META = { color: "#F5F5F5", border: "#BDBDBD", icon: `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="10" y="14" width="44" height="38" rx="4" fill="#E0E0E0" stroke="#9E9E9E" stroke-width="2.5"/><rect x="10" y="22" width="44" height="2" fill="#9E9E9E" opacity="0.3"/><circle cx="24" cy="36" r="6" fill="#9E9E9E" opacity="0.3"/><path d="M34 32h12M34 38h8" stroke="#9E9E9E" stroke-width="2" stroke-linecap="round" opacity="0.5"/></svg>` };

// Keyword rules: order matters — first match wins
const KEYWORD_RULES = [
  // Exact-ish common names
  ["thyroid",     CATEGORY_META["thyroid"]],
  ["diabetes",    CATEGORY_META["diabetes"]],
  ["diabetic",    CATEGORY_META["diabetes"]],
  ["heart",       CATEGORY_META["heart"]],
  ["cardiac",     CATEGORY_META["heart"]],
  ["lipid",       EXTRA_META["lipid"]],
  ["cholesterol", EXTRA_META["lipid"]],
  ["liver",       CATEGORY_META["liver"]],
  ["hepat",       EXTRA_META["hepat"]],
  ["lft",         CATEGORY_META["liver"]],
  ["kidney",      CATEGORY_META["kidney"]],
  ["renal",       EXTRA_META["renal"]],
  ["lung",        CATEGORY_META["lungs"]],
  ["pulmo",       CATEGORY_META["lungs"]],
  ["cancer",      CATEGORY_META["cancer"]],
  ["tumour",      CATEGORY_META["cancer"]],
  ["tumor",       CATEGORY_META["cancer"]],
  ["oncol",       CATEGORY_META["cancer"]],
  ["marker",      CATEGORY_META["cancer"]],
  ["anaemia",     CATEGORY_META["anaemia"]],
  ["anemia",      CATEGORY_META["anaemia"]],
  ["haemoglob",   CATEGORY_META["anaemia"]],
  ["hemoglob",    CATEGORY_META["anaemia"]],
  ["iron",        EXTRA_META["iron"]],
  ["ferrit",      EXTRA_META["iron"]],
  ["thalass",     EXTRA_META["iron"]],
  ["hormone",     EXTRA_META["hormon"]],
  ["hormonal",    EXTRA_META["hormon"]],
  ["endocrin",    EXTRA_META["hormon"]],
  ["fertility",   CATEGORY_META["fertility"]],
  ["infertil",    CATEGORY_META["fertility"]],
  ["semen",       EXTRA_META["semen"]],
  ["sperm",       EXTRA_META["semen"]],
  ["prostate",    CATEGORY_META["prostate"]],
  ["psa",         CATEGORY_META["prostate"]],
  ["pregnancy",   CATEGORY_META["pregnancy"]],
  ["prenatal",    CATEGORY_META["pregnancy"]],
  ["natal",       EXTRA_META["natal"]],
  ["obstetric",   EXTRA_META["natal"]],
  ["torch",       EXTRA_META["torch"]],
  ["viral",       EXTRA_META["viral"]],
  ["virus",       EXTRA_META["viral"]],
  ["hiv",         CATEGORY_META["hiv"]],
  ["aids",        CATEGORY_META["hiv"]],
  ["tuberculosis",CATEGORY_META["tuberculosis"]],
  ["tb ",         CATEGORY_META["tuberculosis"]],
  ["typhoid",     EXTRA_META["fever"]],
  ["malaria",     EXTRA_META["fever"]],
  ["dengue",      EXTRA_META["fever"]],
  ["fever",       EXTRA_META["fever"]],
  ["widal",       EXTRA_META["fever"]],
  ["allerg",      EXTRA_META["allerg"]],
  ["bone",        EXTRA_META["bone"]],
  ["calcium",     EXTRA_META["bone"]],
  ["mineral",     EXTRA_META["bone"]],
  ["vitamin",     CATEGORY_META["vitamins"]],
  ["vitamin",     CATEGORY_META["vitamins"]],
  ["electrolyte", EXTRA_META["electro"]],
  ["sodium",      EXTRA_META["electro"]],
  ["potassium",   EXTRA_META["electro"]],
  ["coagul",      EXTRA_META["coagul"]],
  ["clott",       EXTRA_META["coagul"]],
  ["platelet",    EXTRA_META["coagul"]],
  ["blood",       EXTRA_META["blood"]],
  ["cbc",         EXTRA_META["blood"]],
  ["haemogram",   EXTRA_META["blood"]],
  ["hemogram",    EXTRA_META["blood"]],
  ["urin",        EXTRA_META["urin"]],
  ["stool",       EXTRA_META["stool"]],
  ["faecal",      EXTRA_META["stool"]],
  ["fecal",       EXTRA_META["stool"]],
  ["cultur",      EXTRA_META["cultur"]],
  ["sensitiv",    EXTRA_META["cultur"]],
  ["microbi",     EXTRA_META["cultur"]],
  ["surgical",    EXTRA_META["surgical"]],
  ["surgery",     EXTRA_META["surgical"]],
  ["pre-op",      EXTRA_META["surgical"]],
  ["preop",       EXTRA_META["surgical"]],
  ["immunolog",   CATEGORY_META["immunity"]],
  ["autoimmune",  CATEGORY_META["autoimmune disorders"]],
  ["inflamm",     CATEGORY_META["inflammatory markers"]],
  ["stomach",     CATEGORY_META["stomach"]],
  ["gastro",      CATEGORY_META["stomach"]],
  ["toxicol",     CATEGORY_META["toxicology"]],
  ["drug level",  CATEGORY_META["drug level monitoring"]],
  ["heavy metal", CATEGORY_META["heavy metals"]],
  ["compreh",     EXTRA_META["compreh"]],
  ["complete",    EXTRA_META["compreh"]],
  ["full body",   EXTRA_META["compreh"]],
  ["senior",      EXTRA_META["compreh"]],
  ["wellness",    EXTRA_META["compreh"]],
  ["package",     EXTRA_META["compreh"]],
  ["profile",     EXTRA_META["compreh"]],
  ["panel",       EXTRA_META["compreh"]],
  ["screening",   EXTRA_META["compreh"]],
];
  // ─── Styles ────────────────────────────────────────────────────────────────
  const styles = {
    container: { flex: 1, backgroundColor: "#F9FAFB", minHeight: "100vh", paddingBottom: "100px", marginLeft: window.innerWidth >= 900 ? "280px" : 0 }, 
    header: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px", backgroundColor: "#fff", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", position: "sticky", top: 0, zIndex: 1000 },    backButton: { padding: "8px", border: "none", background: "none", cursor: "pointer" },
    headerTitle: { fontSize: "20px", fontWeight: "700", color: "#006D77", margin: 0 },
    scrollContent: { padding: "16px", maxWidth: "900px", margin: "0 auto", width: "90%" },
    card: { backgroundColor: "#fff", borderRadius: "16px", padding: "20px", marginBottom: "16px", boxShadow: "0 2px 8px rgba(0,0,0,0.08)" },
    cardTitle: { fontSize: "18px", fontWeight: "700", color: "#111827", marginBottom: "16px", marginTop: 0 },
    cartItem: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px", backgroundColor: "#F9FAFB", borderRadius: "12px", marginBottom: "12px" },
    itemDetails: { flex: 1 },
    itemName: { fontSize: "15px", fontWeight: "600", color: "#111827", marginBottom: "4px" },
    itemPrice: { fontSize: "14px", color: "#6B7280" },
    quantityControl: { display: "flex", alignItems: "center", gap: "12px" },
    qtyButton: { width: "32px", height: "32px", borderRadius: "8px", border: "1px solid #D1D5DB", backgroundColor: "#fff", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" },
    qtyText: { fontSize: "16px", fontWeight: "600", minWidth: "24px", textAlign: "center" },
    deleteButton: { padding: "8px", border: "none", background: "none", cursor: "pointer", color: "#EF4444" },
    addressSummary: { padding: "16px", backgroundColor: "#F9FAFB", borderRadius: "12px", marginBottom: "12px" },
    editButton: { display: "flex", alignItems: "center", gap: "8px", padding: "10px 16px", backgroundColor: "#006D77", color: "#fff", border: "none", borderRadius: "8px", cursor: "pointer", fontSize: "14px", fontWeight: "600", marginTop: "12px" },
    closeButton: { padding: "8px", border: "none", background: "none", cursor: "pointer", color: "#6B7280", display: "flex", alignItems: "center", gap: "4px", fontSize: "14px", fontWeight: "600" },
    summaryRow: { display: "flex", justifyContent: "space-between", marginBottom: "12px" },
    summaryLabel: { fontSize: "14px", color: "#6B7280" },
    summaryValue: { fontSize: "14px", fontWeight: "600", color: "#111827" },
    divider: { height: "1px", backgroundColor: "#E5E7EB", margin: "12px 0" },
    promoInput: { display: "flex", gap: "8px", marginTop: "12px" },
    input: { flex: 1, border: "1px solid #D1D5DB", borderRadius: "8px", padding: "10px 12px", fontSize: "14px", fontFamily: "inherit" },
    button: { padding: "10px 20px", borderRadius: "8px", border: "none", cursor: "pointer", fontSize: "14px", fontWeight: "600" },
    primaryButton: { backgroundColor: "#006D77", color: "#fff" },
    secondaryButton: { backgroundColor: "#fff", color: "#006D77", border: "1px solid #006D77" },
    dangerButton: { backgroundColor: "#EF4444", color: "#fff" },
    promoTag: { display: "inline-flex", alignItems: "center", gap: "8px", backgroundColor: "#D1FAE5", color: "#065F46", padding: "8px 12px", borderRadius: "8px", fontSize: "14px", fontWeight: "600", marginTop: "8px" },
    promoCard: { border: "1px solid #E5E7EB", borderRadius: "12px", padding: "16px", marginBottom: "12px", cursor: "pointer" },
    inputGroup: { marginBottom: "20px" },
    label: { fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "8px", display: "block" },
    required: { color: "#EF4444" },
    formInput: { width: "100%", border: "1px solid #D1D5DB", borderRadius: "8px", padding: "12px 16px", fontSize: "16px", color: "#111827", backgroundColor: "#fff", boxSizing: "border-box", fontFamily: "inherit" },
    inputError: { borderColor: "#EF4444" },
    errorText: { fontSize: "12px", color: "#EF4444", marginTop: "4px" },
    addressTypeButton: { flex: 1, padding: "12px", borderRadius: "8px", border: "1px solid #D1D5DB", textAlign: "center", cursor: "pointer", backgroundColor: "#fff" },
    addressTypeButtonActive: { backgroundColor: "#006D77", borderColor: "#006D77" },
    addressTypeText: { fontSize: "14px", fontWeight: "600", color: "#6B7280" },
    addressTypeTextActive: { color: "#fff" },
    buttonContainer: { position: "fixed", bottom: 0, left: window.innerWidth >= 900 ? "280px" : 0, right: 0, backgroundColor: "#fff", padding: "16px", boxShadow: "0 -2px 8px rgba(0,0,0,0.1)", zIndex: 1000 },
  proceedButton: { backgroundColor: "#006D77", padding: "16px", borderRadius: "12px", display: "flex", justifyContent: "center", alignItems: "center", border: "none", cursor: "pointer", maxWidth: "900px", margin: "0 auto", width: "100%" },
    proceedButtonText: { color: "#fff", fontSize: "16px", fontWeight: "700", marginRight: "8px" },
    proceedButtonAmount: { color: "#fff", fontSize: "18px", fontWeight: "700" },
  };


function getCategoryMeta(cat) {
  const key = (cat || "").toLowerCase().trim();
  // 1. Try exact match first
  if (CATEGORY_META[key]) return CATEGORY_META[key];
  // 2. Try keyword rules
  for (const [keyword, meta] of KEYWORD_RULES) {
    if (key.includes(keyword)) return meta;
  }
  // 3. Fallback
  return DEFAULT_META;
}
function CategorySVG({ meta, size = 56 }) {
  return (
    <img
      src={`data:image/svg+xml;charset=utf-8,${encodeURIComponent(meta.icon)}`}
      alt=""
      style={{ width: size, height: size, objectFit: "contain", display: "block" }}
    />
  );
}

// ─── STEP BAR ─────────────────────────────────────────────────────────────────
function StepBar({ step }) {
  const steps = ["Choose Tests", "Review Cart", "Book Appointment"];
  return (
    <Box sx={{ display: "flex", alignItems: "center", mb: 0 }}>
      {steps.map((label, i) => {
        const num = i + 1;
        const done = step > num;
        const active = step === num;
        return (
          <React.Fragment key={num}>
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", flex: 1 }}>
              <Box sx={{
                width: 30, height: 30, borderRadius: "50%",
                bgcolor: done || active ? "#006D77" : "#E0E0E0",
                color: done || active ? "#fff" : "#999",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: 12, fontWeight: 700,
                border: active ? "3px solid #B2DFDB" : "none",
                transition: "all 0.3s",
              }}>
                {done ? <CheckCircleIcon sx={{ fontSize: 16 }} /> : num}
              </Box>
              <Typography sx={{ fontSize: 10, mt: 0.5, fontWeight: active ? 700 : 400, color: active || done ? "#006D77" : "#bbb", whiteSpace: "nowrap" }}>
                {label}
              </Typography>
            </Box>
            {i < steps.length - 1 && (
              <Box sx={{ height: 2, flex: 1, bgcolor: step > num ? "#006D77" : "#E0E0E0", mb: 2.5, transition: "all 0.4s" }} />
            )}
          </React.Fragment>
        );
      })}
    </Box>
  );
}

// ─── CATEGORY CARD (MedPlus style) ───────────────────────────────────────────
function CategoryCard({ name, count, isActive, onClick }) {
  const meta = getCategoryMeta(name);
  return (
    <Box
      onClick={onClick}
      sx={{
        display: "flex", flexDirection: "column", alignItems: "center",
        justifyContent: "flex-start",
        p: { xs: 1.5, sm: 2 }, pt: { xs: 2, sm: 2.5 }, pb: { xs: 1.5, sm: 2 },
        borderRadius: 3, cursor: "pointer",
        bgcolor: isActive ? meta.color : "#fff",
        border: isActive ? `2px solid ${meta.border}` : "1.5px solid #EEEEEE",
        boxShadow: isActive ? `0 0 0 3px ${meta.border}22` : "0 1px 4px rgba(0,0,0,0.06)",
        transition: "all 0.18s ease",
        minHeight: { xs: 90, sm: 110 },
        "&:hover": {
          borderColor: meta.border,
          boxShadow: `0 4px 16px ${meta.border}28`,
          transform: "translateY(-2px)",
          bgcolor: meta.color,
        },
      }}
    >
      <Box sx={{
        width: { xs: 52, sm: 64 }, height: { xs: 52, sm: 64 },
        borderRadius: 2.5, bgcolor: meta.color,
        display: "flex", alignItems: "center", justifyContent: "center",
        mb: 1, border: `1px solid ${meta.border}33`,
      }}>
        <CategorySVG meta={meta} size={isActive ? 44 : 40} />
      </Box>
      <Typography sx={{
        fontSize: { xs: 10, sm: 11 }, fontWeight: isActive ? 700 : 500,
        color: isActive ? meta.border : "#444",
        textAlign: "center", lineHeight: 1.3,
        display: "-webkit-box", WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical", overflow: "hidden",
        wordBreak: "break-word",
      }}>
        {name}
      </Typography>
    </Box>
  );
}

// ─── TEST CARD (MedPlus style exactly) ───────────────────────────────────────
function TestCard({ test, isInCart, onAdd, onRemove }) {
  const [showInfo, setShowInfo] = useState(false);
  const price = test.non_membership || test.proposed_rate || test.mrp || 0;
  const mrp = test.mrp || 0;
  const hasDiscount = mrp > 0 && price < mrp;
  const meta = getCategoryMeta(test.category);

  return (
    <Box sx={{
      borderRadius: 2.5, bgcolor: "#fff",
      border: isInCart ? "1.5px solid #006D77" : "1px solid #EEEEEE",
      boxShadow: isInCart ? "0 2px 16px rgba(0,109,119,0.12)" : "0 1px 6px rgba(0,0,0,0.06)",
      overflow: "hidden",
      transition: "all 0.2s",
      display: "flex", flexDirection: "column",
      "&:hover": { boxShadow: "0 4px 20px rgba(0,0,0,0.1)", transform: "translateY(-1px)" },
    }}>
      {/* Card body */}
      <Box sx={{ p: 2, flex: 1 }}>
        {/* Test name + info icon */}
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 2 }}>
          <Typography sx={{ fontSize: 13.5, fontWeight: 700, color: "#1a1a1a", lineHeight: 1.4, flex: 1, pr: 1 }}>
            {test.test_name}
          </Typography>
          <IconButton
            size="small"
            onClick={() => setShowInfo((v) => !v)}
            sx={{
              p: 0.3, flexShrink: 0, mt: 0.1,
              color: showInfo ? "#006D77" : "#BDBDBD",
              "&:hover": { color: "#006D77", bgcolor: "#E0F7FA" },
              transition: "color 0.2s",
            }}
          >
            <InfoOutlinedIcon sx={{ fontSize: 28 ,color: "#006D77",}} />
          </IconButton>
        </Box>

        {/* ── About This Test expandable panel ── */}
        <Collapse in={showInfo} timeout={250}>
          <Box sx={{
            mb: 2, p: 1.5, borderRadius: 2,
            bgcolor: meta.color,
            border: `1px solid ${meta.border}44`,
            position: "relative",
          }}>
            {/* Close button */}
            <IconButton
              size="small"
              onClick={() => setShowInfo(false)}
              sx={{
                position: "absolute", top: 6, right: 6,
                p: 0.2, color: "#999",
                "&:hover": { color: "#333", bgcolor: "rgba(0,0,0,0.06)" },
              }}
            >
              <CloseIcon sx={{ fontSize: 13 }} />
            </IconButton>

            <Box sx={{ display: "flex", alignItems: "center", gap: 0.8, mb: 1 }}>
              <InfoOutlinedIcon sx={{ fontSize: 13, color: meta.border }} />
              <Typography sx={{ fontSize: 11, fontWeight: 700, color: meta.border }}>
                About This Test
              </Typography>
            </Box>

            {test.description ? (
              <Typography sx={{ fontSize: 11.5, color: "#444", lineHeight: 1.6, pr: 2 }}>
                {test.description}
              </Typography>
            ) : (
              <Typography sx={{ fontSize: 11.5, color: "#888", lineHeight: 1.6, fontStyle: "italic" }}>
                No description available for this test.
              </Typography>
            )}

            {/* Extra info chips if available */}
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, mt: test.description ? 1.5 : 1 }}>
              {test.parameters && (
                <Chip
                  label={`${test.parameters} Parameters`}
                  size="small"
                  sx={{ height: 20, fontSize: 9.5, fontWeight: 600, bgcolor: "#fff", color: meta.border, border: `1px solid ${meta.border}66`, "& .MuiChip-label": { px: 1 } }}
                />
              )}
              {test.sample_type && (
                <Chip
                  label={`Sample: ${test.sample_type}`}
                  size="small"
                  sx={{ height: 20, fontSize: 9.5, fontWeight: 600, bgcolor: "#fff", color: "#666", border: "1px solid #DDD", "& .MuiChip-label": { px: 1 } }}
                />
              )}
              {test.test_code && (
                <Chip
                  label={`Code: ${test.test_code}`}
                  size="small"
                  sx={{ height: 20, fontSize: 9.5, bgcolor: "#fff", color: "#999", border: "1px solid #EEE", "& .MuiChip-label": { px: 1 } }}
                />
              )}
            </Box>
          </Box>
        </Collapse>

        {/* MA Price row */}
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
          <Box>
            <Typography sx={{ fontSize: 10, color: "#999", mb: 0.2 }}>Our Price</Typography>
            <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#1a1a1a" }}>
              ₹{price.toFixed(2)}
            </Typography>
          </Box>
          {isInCart ? (
            <Button
              size="small"
              variant="outlined"
              onClick={() => onRemove(test)}
              sx={{
                borderColor: "#006D77", color: "#006D77",
                textTransform: "none", fontSize: 11, fontWeight: 600,
                borderRadius: 5, px: 1.5, py: 0.4, minWidth: "auto",
                "&:hover": { bgcolor: "#E0F7FA" },
              }}
            >
              ✓ Added
            </Button>
          ) : (
            <Button
              size="small"
              variant="outlined"
              sx={{
                borderColor: "#BDBDBD", color: "#555",
                textTransform: "none", fontSize: 10, fontWeight: 500,
                borderRadius: 5, px: 1.5, py: 0.4,
              }}
            >
              Get Ayuja<br />
              <span style={{ fontSize: 9, color: "#006D77", fontWeight: 700 }}>Advantage</span>
            </Button>
          )}
        </Box>

        {/* MRP row */}
        <Box sx={{ mb: 1.5 }}>
          <Typography sx={{ fontSize: 10, color: "#999", mb: 0.2 }}>MRP</Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#1a1a1a",textDecoration: "line-through" }}>
              ₹{mrp.toFixed(2)}
            </Typography>
            {hasDiscount && (
              <Chip
                label={`${Math.round(((mrp - price) / mrp) * 100)}% off`}
                size="small"
                sx={{ height: 18, fontSize: 9, fontWeight: 700, bgcolor: "#E8F5E9", color: "#2E7D32", "& .MuiChip-label": { px: 1 } }}
              />
            )}
          </Box>
        </Box>
      </Box>

      {/* Add to Cart button */}
      <Box sx={{ px: 2, pb: 1.5 }}>
        <Button
          fullWidth
          variant="contained"
          onClick={isInCart ? () => onRemove(test) : () => onAdd(test)}
          sx={{
            borderRadius: 5, py: 0.9,
            textTransform: "none", fontWeight: 700, fontSize: 13,
            background: isInCart
              ? "linear-gradient(90deg, #004F55 0%, #006D77 100%)"
              : "linear-gradient(90deg, #006D77 0%, #00838F 100%)",
            boxShadow: "0 3px 10px rgba(0,109,119,0.3)",
            "&:hover": { background: "linear-gradient(90deg, #004048 0%, #005F6B 100%)" },
          }}
        >
          {isInCart ? "✓ Remove from Cart" : "Add To Cart"}
        </Button>
      </Box>

      {/* Sample collection footer */}
      <Box sx={{
        px: 2, py: 1.2, bgcolor: "#FAFAFA",
        borderTop: "1px solid #F0F0F0",
      }}>
        <Typography sx={{ fontSize: 9.5, color: "#999", mb: 0.2 }}>Sample Collection Option</Typography>
        <Typography sx={{ fontSize: 11, fontWeight: 600, color: "#555" }}>
          {test.sample_type ? `${test.sample_type} · Home collection` : "Home collection & Lab Walk-in"}
        </Typography>
      </Box>
    </Box>
  );
}

// ─── CART REVIEW ──────────────────────────────────────────────────────────────
function CartReview({ cart, onRemove, onContinue,appliedPromo,setAppliedPromo }) {

  const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogMessage, setDialogMessage] = useState("");
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
  
    // Promo
    const [promoCode, setPromoCode] = useState("");
    const [promoLoading, setPromoLoading] = useState(false);
    const [showAvailablePromos, setShowAvailablePromos] = useState(false);
    const [availablePromos, setAvailablePromos] = useState([]);
    const [promoMsg, setPromoMsg] = useState("")
    const [promotype, setPromotype] = useState("")
  const total = cart.reduce((s, t) => s + (t.non_membership || t.proposed_rate || t.mrp || 0), 0);
  const mrpTotal = cart.reduce((s, t) => s + (t.mrp || 0), 0);
  const discountAmount = appliedPromo
  ? Number(appliedPromo.discount) || 0
  : 0;
  const savings = mrpTotal 

const finalAmount = Math.max(0, total - discountAmount);
  const justAppliedPromo = React.useRef(false);


    useEffect(() => {
      const fetchAvailablePromos = async () => {
        try {
          const userId = sessionStorage.getItem("userId");
          const response = await axios.get(
            `${process.env.REACT_APP_APPLY_PROMOTION_API}/available?service_type=diagnostic&user_id=${userId}`,
            { headers: { "Content-Type": "application/json" } }
          );
          const data = response.data;
          if (data?.success) setAvailablePromos(data.promotions || []);
        } catch (error) {
          console.error("Error fetching promos:", error);
        }
      };
      fetchAvailablePromos();
    }, []);
// ─── Promo helpers ─────────────────────────────────────────────────────────
  const applyPromoCode = async (code) => {
    const userId = sessionStorage.getItem("userId");
    const payload = {
      promo_code: code.toUpperCase(),
      service_type:"diagnostic",
      order_price: total,
      user_id: userId,
      test_ids: cart.map(test => test.id),
      categories: [
        ...new Set(cart.map(test => test.category))
      ]
    };
    setPromoLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_APPLY_PROMOTION_API}/apply`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );
      const data = response.data;
      if (data.success) {
        justAppliedPromo.current = true;
        setAppliedPromo({ code: data.promo_code, discount: data.discount_amount, title: data.title });
        setPromoCode(""); setShowAvailablePromos(false);
        setPromoMsg("Applied")
        setPromotype("success")
        setDialogMessage(data.message || "Promo code applied successfully!"); setDialogOpen(true);
      } else {
        setPromoMsg("Invalid")
        setPromotype("error")
        setDialogMessage(data.error || "Invalid promo code"); setDialogOpen(true);
      }
    } catch {
      setDialogMessage("Failed to apply promo code. Please try again."); setDialogOpen(true);
    } finally {
      setPromoLoading(false);
    }
  };

  const validateAppliedPromo = async () => {
    if (!appliedPromo) return;
    if (justAppliedPromo.current) { justAppliedPromo.current = false; return; }
    try {
      const userId = sessionStorage.getItem("userId");
      const response = await axios.post(
        `${process.env.REACT_APP_APPLY_PROMOTION_API}/apply`,
        { promo_code: appliedPromo.code, service_type: "diagnostic", order_price: total, user_id: userId },
        { headers: { "Content-Type": "application/json" } }
      );
      const data = response.data;
      if (!data.success) {
        setAppliedPromo(null);
        setDialogMessage(`Promo "${appliedPromo.code}" removed. ${data.error || "Cart no longer meets requirements."}`);
        setDialogOpen(true);
      } else if (data.discount_amount !== appliedPromo.discount) {
        setPromoMsg("Applied")
        setPromotype("success")
        setAppliedPromo({ code: data.promo_code, discount: data.discount_amount, title: data.title });
      }
    } catch { setAppliedPromo(null); }
  };

  const removePromoCode = () => {
    setAppliedPromo(null); setDialogMessage("Promo code removed"); setDialogOpen(true);setPromoMsg("Removed!");
  };

  return (
    <Box>
      <Typography fontWeight={800} fontSize={20} color="#1a1a1a" mb={0.5}>Your Cart</Typography>
      <Typography fontSize={12} color="#999" mb={3}>{cart.length} test{cart.length > 1 ? "s" : ""} selected</Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, mb: 3 }}>
        {cart.map((test) => {
          const meta = getCategoryMeta(test.category);
          const price = test.non_membership || test.proposed_rate || test.mrp || 0;
          return (
            <Box key={test.id} sx={{
              display: "flex", alignItems: "center", gap: 2,
              p: 2, borderRadius: 2.5, bgcolor: "#fff",
              border: "1px solid #EEEEEE",
              boxShadow: "0 1px 6px rgba(0,0,0,0.05)",
            }}>
              <Box sx={{
                width: 44, height: 44, borderRadius: 2, flexShrink: 0,
                bgcolor: meta.color, display: "flex", alignItems: "center", justifyContent: "center",
                border: `1px solid ${meta.border}44`,
              }}>
                <CategorySVG meta={meta} size={30} />
              </Box>
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#1a1a1a", lineHeight: 1.3 }}>
                  {test.test_name}
                </Typography>
                <Typography sx={{ fontSize: 10.5, color: "#999", mt: 0.3 }}>{test.category}</Typography>
              </Box>
              <Box sx={{ textAlign: "right", flexShrink: 0 }}>
                <Typography sx={{ fontSize: 15, fontWeight: 800, color: "#1a1a1a" }}>₹{price.toFixed(2)}</Typography>
                {test.mrp && price < test.mrp && (
                  <Typography sx={{ fontSize: 10, color: "#bbb", textDecoration: "line-through" }}>₹{test.mrp}</Typography>
                )}
              </Box>
              <IconButton size="small" onClick={() => onRemove(test)} sx={{ color: "#EF5350", flexShrink: 0 }}>
                <DeleteOutlineIcon fontSize="small" />
              </IconButton>

            </Box>
          );
        })}
      </Box>

      {/* Price Summary */}
      <Box sx={{ borderRadius: 3, border: "1px solid #EEEEEE", overflow: "hidden", mb: 3 }}>
        <Box sx={{ bgcolor: "#006D77", px: 2.5, py: 1.5 }}>
          <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: 13 }}>Price Summary</Typography>
        </Box>
        <Box sx={{ bgcolor: "#FAFFFE", p: 2.5 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
            <Typography fontSize={13} color="#666">Total MRP</Typography>
            <Typography fontSize={13} fontWeight={600}>₹{mrpTotal.toFixed(2)}</Typography>
          </Box>
             {/* Promo section */}
                    {!appliedPromo ? (
                      <>
                        <div style={styles.promoInput}>
                          <input type="text" placeholder="Enter promo code" value={promoCode}
                            onChange={(e) => setPromoCode(e.target.value.toUpperCase())} style={styles.input} />
                          <button onClick={() => applyPromoCode(promoCode)} disabled={!promoCode || promoLoading}
                            style={{ ...styles.button, ...styles.primaryButton, opacity: !promoCode ? 0.5 : 1 }}>
                            {promoLoading ? "Applying..." : "Apply"}
                          </button>
                        </div>
                        <button onClick={() => setShowAvailablePromos(!showAvailablePromos)}
                          style={{ ...styles.button, ...styles.secondaryButton, width: "100%", marginTop: "8px", display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                          <Tag size={16} /> View Available Offers
                          {showAvailablePromos ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                        </button>
                       
                        {showAvailablePromos && availablePromos.length > 0 && (
                          <div style={{ marginTop: "12px" }}>
                            {availablePromos.map((promo, index) => (
                              <div key={index} style={styles.promoCard}
                                onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#006D77"; e.currentTarget.style.backgroundColor = "#F0FDFA"; }}
                                onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#E5E7EB"; e.currentTarget.style.backgroundColor = "#fff"; }}
                                onClick={() => applyPromoCode(promo.promo_code)}>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start" }}>
                                  <div>
                                    <div style={{ fontSize: "16px", fontWeight: "700", color: "#111827", marginBottom: "4px" }}>{promo.promo_code}</div>
                                    <div style={{ fontSize: "14px", color: "#6B7280", marginBottom: "8px" }}>{promo.description}</div>
                                    <div style={{ fontSize: "12px", color: "#9CA3AF" }}>
                                      Min order: ₹{promo.min_order_value}{promo.max_discount > 0 && ` • Max discount: ₹${promo.max_discount}`}
                                    </div>
                                  </div>
                                  <button style={{ ...styles.button, ...styles.primaryButton, fontSize: "12px", padding: "6px 12px" }}>Apply</button>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </>
                    ) : (
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        <div style={styles.promoTag}><Tag size={16} />{appliedPromo.code} Applied</div>
                        <button onClick={removePromoCode} style={{ ...styles.button, ...styles.dangerButton, fontSize: "12px", padding: "6px 12px" }}>Remove</button>
                      </div>
                    )}
                    {appliedPromo && (
                    <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                      <Typography
                        fontSize={13}
                        color="#d97706"
                        fontWeight={600}
                        sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                      >
                        <LocalOfferIcon sx={{ fontSize: 14 }} />
                        Promo ({appliedPromo.code})
                      </Typography>

                      <Typography
                        fontSize={13}
                        color="#d97706"
                        fontWeight={700}
                      >
                        -₹{discountAmount.toFixed(2)}
                      </Typography>
                    </Box>
                  )}
          {savings > 0 && (
            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
              <Typography fontSize={13} color="#2E7D32" fontWeight={600} sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <LocalOfferIcon sx={{ fontSize: 14 }} /> Total Savings
              </Typography>
              <Typography fontSize={13} color="#2E7D32" fontWeight={700}>-₹{savings.toFixed(2)}</Typography>
            </Box>
          )}
          <Divider sx={{ my: 1.5 }} />
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography fontSize={15} fontWeight={800}>Total Payable</Typography>
          <Typography fontSize={15} fontWeight={800} color="#006D77">
            ₹{finalAmount.toFixed(2)}
          </Typography>
          </Box>
        </Box>
      </Box>

      <Button
        fullWidth variant="contained"
        onClick={onContinue}
        disabled={!cart || cart.length === 0}
        endIcon={<KeyboardArrowRightIcon />}
        sx={{
          background: "linear-gradient(90deg, #006D77 0%, #00838F 100%)",
          borderRadius: 3, py: 1.8,
          fontSize: 15, fontWeight: 800, textTransform: "none",
          boxShadow: "0 6px 20px rgba(0,109,119,0.4)",
          "&:hover": { background: "linear-gradient(90deg, #004F55 0%, #006064 100%)" },
        }}
      >
        Continue to Book Appointment
      </Button>
            <CustomDialog open={dialogOpen} message={dialogMessage} title={promoMsg} type={promotype} onClose={() => setDialogOpen(false)} />

    </Box>
  );
}

// ─── FLOATING CART BAR ────────────────────────────────────────────────────────
function CartBar({ cart, onViewCart }) {
  if (cart.length === 0) return null;
  const total = cart.reduce((s, t) => s + (t.non_membership || t.proposed_rate || t.mrp || 0), 0);
  return (
    <Box sx={{
      position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 1000,
      background: "linear-gradient(90deg, #006D77 0%, #004F55 100%)",
      color: "#fff", px: { xs: 2, md: 4 }, py: 1.5,
      display: "flex", alignItems: "center", justifyContent: "space-between",
      boxShadow: "0 -4px 24px rgba(0,109,119,0.3)",
    }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Badge badgeContent={cart.length} color="error">
          <ShoppingCartOutlinedIcon />
        </Badge>
        <Box>
          <Typography sx={{ fontSize: 11, opacity: 0.8 }}>
            {cart.length} test{cart.length > 1 ? "s" : ""} in cart
          </Typography>
          <Typography sx={{ fontSize: 16, fontWeight: 800 }}>₹{total.toFixed(2)}</Typography>
        </Box>
      </Box>
      <Button
        variant="contained"
        onClick={onViewCart}
        endIcon={<KeyboardArrowRightIcon />}
        sx={{
          bgcolor: "#fff", color: "#006D77",
          fontWeight: 800, fontSize: 13, textTransform: "none",
          borderRadius: 2.5, px: 3, py: 1,
          "&:hover": { bgcolor: "#E0F7FA" },
        }}
      >
        View Cart
      </Button>
    </Box>
  );
}

// ─── MAIN ─────────────────────────────────────────────────────────────────────
const DiagnosticDeliveryScreen = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [cart, setCart] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userLoading, setUserLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState(null);
  const [search, setSearch] = useState("");
  const [step, setStep] = useState(1);

  const [categories, setCategories] = useState([]);
  const [tests, setTests] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalTests, setTotalTests] = useState(0);
  const [testsLoading, setTestsLoading] = useState(false);
  const [catLoading, setCatLoading] = useState(true);
  const LIMIT = 20;
  const [packages, setPackages] = useState([]);
  const [showAllPackagesModal, setShowAllPackagesModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [appliedPromo, setAppliedPromo] = useState(null);
  const API = process.env.REACT_APP_API_BASE_URL;


  useEffect(() => {
    // Fetch user
    const fetchUser = async () => {
      setUserLoading(true);
      const stored = sessionStorage.getItem("user");
      if (stored) setUser(JSON.parse(stored));
      const userId = sessionStorage.getItem("userId");
      const token = sessionStorage.getItem("token");
      if (userId && token) {
        try {
          const ud = await fetchUserFromRedis(userId, token);
          if (ud) { setUser(ud); sessionStorage.setItem("user", JSON.stringify(ud)); }
        } catch (e) { console.error(e); }
      }
      setUserLoading(false);
    };
    fetchUser();
  
    // Fetch categories
    fetchCategories();
  }, []);


  // ✅ CORRECT FIX — replace both useEffects with this
  const pageRef = useRef(1);
  const categoryRef = useRef(activeCategory);
  const resetPage = () => { pageRef.current = 1; setPage(1); };

// useEffect(() => { searchRef.current = search; }, [search]);
useEffect(() => { categoryRef.current = activeCategory; }, [activeCategory]);

// ✅ Search / category change — debounced, resets page to 1
useEffect(() => {
  const timer = setTimeout(() => {
    pageRef.current = 1;        // update ref immediately
    setPage(1);                 // update display (won't trigger fetchTests again)
    fetchTests(1, activeCategory, search);
  }, search ? 400 : 0);
  return () => clearTimeout(timer);
}, [search, activeCategory]);   // ← only these two

// ✅ Pagination clicks only
useEffect(() => {
  fetchTests(page, activeCategory, search);
}, [page]);                     // ← only page


// Fetch categories once on mount
const fetchCategories = async () => {
  setCatLoading(true);
  try {
    const res = await apiRequest(`${BASE_URL}/diagnostic-categories`);
    const data = await res.json();
        const updatedCategories = [
      { name: "Packages" },
      ...data.categories
    ];
     setCategories(updatedCategories);
  } catch { setError("Failed to load categories."); }
  finally { setCatLoading(false); }
};

useEffect(()=>{
    getAvailablePackages()
  },[activeCategory])

const handlePageChange = (event, value) => { setCurrentPage(value); window.scrollTo({ top: 400, behavior: 'smooth' }); };

// Fetch tests whenever page/category/search changes
const fetchTests = async (pageNum, cat, searchVal) => {
  setTestsLoading(true);
  try {
    const params = new URLSearchParams({
      page: pageNum,
      limit: LIMIT,
      ...(searchVal && { search: searchVal }),
      ...(cat && { category: cat }),
    });
    const res = await apiRequest(`${BASE_URL}/diagnostic-tests?${params}`);
    const data = await res.json();
    setTests(data.tests);
    setTotalPages(data.total_pages);
    setTotalTests(data.total);
  } catch { setError("Failed to load tests."); }
  finally { setTestsLoading(false); }
};
const getAvailablePackages=async()=>{
  setLoading(true);
      try {
        const res  = await fetch(`${API}/health-camp/packages`);
        const data = await res.json();
        if (data.success) setPackages(data.packages || []);
      } catch (err) { console.error(err); }
      finally { setLoading(false); }
    }

  const getKey = (t) => t.id || t.test_name;
  const cartIds = useMemo(() => new Set(cart.map((t) => t.id)), [cart]);
  const addToCart = (test) => setCart((p) => [...p, test]);
  const removeFromCart = (test) => setCart((p) => p.filter((t) => t.id !== test.id));
  const calcTotal = () => cart.reduce((s, t) => s + (t.non_membership || t.proposed_rate || t.mrp || 0), 0);
  const calcMRP = () => cart.reduce((s, t) => s + (t.mrp || 0), 0);
  const promoDiscount = appliedPromo
  ? Number(appliedPromo.discount) || 0
  : 0;
  const calcSavings = () => calcMRP() - calcTotal();

const finalPayable = Math.max(0, calcTotal() - promoDiscount);

  const handleBack = () => {
    if (step > 1) setStep(step - 1);
    else { sessionStorage.removeItem("commonFormData"); navigate("/services"); }
  };

  return (
    <>
      <Box sx={{ minHeight: "100vh", bgcolor: "#F7FAFA", pb: cart.length > 0 && step === 1 ? 9 : 0 }}>

        {/* ── TOP NAV ── */}
        <Box sx={{
           backgroundImage: `
              linear-gradient(135deg, rgba(0,109,119,0.9) 0%, rgba(0, 169, 181, 0.61) 100%),
              url(${bg2})
            `,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat", borderBottom: "1px solid #EEEEEE",
          px: { xs: 2, md: 4 }, py: 1.5,
          display: "flex", alignItems: "center", gap: 2,
          position: "sticky", top: 0, zIndex: 10,
          boxShadow: "0 1px 8px rgba(0,0,0,0.06)",
        }}>
          <IconButton onClick={handleBack} size="small" sx={{color:"#fff",'&:hover': { bgcolor: '#fff!important',color:"#006D77"}}}>
            <ArrowBackIosNewIcon sx={{ fontSize: 14}} />
          </IconButton>
          <Avatar src={DiagnosticSample} sx={{ width: 36, height: 36, borderRadius: 1.5 }} />
          <Box sx={{ flex: 1 }}>
            <Typography fontWeight={700} fontSize={14} color="#ffffff">Diagnostic Sample Collection</Typography>
            <Typography fontSize={10} color="#fff">Home collection · Results in 24–48 hrs</Typography>
          </Box>
          {step === 1 && cart.length > 0 && (
            <Badge badgeContent={cart.length} color="error">
              <IconButton size="small" onClick={() => setStep(2)} sx={{ bgcolor: "#E0F7FA" }}>
                <ShoppingCartOutlinedIcon sx={{ color: "#006D77", fontSize: 20 }} />
              </IconButton>
            </Badge>
          )}
        </Box>

        <Container maxWidth="lg" sx={{ pt: 3, pb: 4 }}>

          {/* Step bar */}
          <Box sx={{ bgcolor: "#fff", borderRadius: 3, p: 2.5, mb: 3, border: "1px solid #EEEEEE" }}>
            <StepBar step={step} />
          </Box>

          {/* ── STEP 1: BROWSE ── */}
          {step === 1 && (
            <>
              {error && <Alert severity="error" sx={{ mb: 2, borderRadius: 2 }}>{error}</Alert>}
              {/* Search */}
              <TextField
                    fullWidth
                    placeholder="Search diagnostic tests by name or code..."
                    value={search}
                    onChange={(e) => { setSearch(e.target.value); if (e.target.value) setActiveCategory(null); }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon sx={{ color: "#006D77" }} />
                        </InputAdornment>
                      ),
                      endAdornment: search ? (
                        <InputAdornment position="end">
                          <IconButton size="small" onClick={() => setSearch("")}>
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </InputAdornment>
                      ) : null,
                    }}
                    sx={{
                      mb: 3,
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 3, bgcolor: "#fff",
                        "& fieldset": { borderColor: "#E0E0E0" },
                        "&:hover fieldset": { borderColor: "#006D77" },
                        "&.Mui-focused fieldset": { borderColor: "#006D77", borderWidth: 2 },
                      },
                    }}
                  />
              {(testsLoading || catLoading) ? (
                <Box sx={{ display: "flex", justifyContent: "center", py: 10 }}>
                  <CircularProgress sx={{ color: "#006D77" }} />
                </Box>
              ) : (
                <>
                  

                  {/* Category grid — hidden during search */}
                  {!search && (
                    <Box sx={{ bgcolor: "#fff", borderRadius: 3, p: { xs: 2, md: 3 }, mb: 3, border: "1px solid #EEEEEE" }}>
                      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
                        <Typography fontWeight={700} fontSize={15} color="#1a1a1a">
                          Condition Based Diagnostic Tests
                        </Typography>
                        {activeCategory && (
                          <Chip
                            label="Clear filter"
                            size="small"
                            onClick={() => setActiveCategory(null)}
                            onDelete={() => setActiveCategory(null)}
                            deleteIcon={<CloseIcon sx={{ fontSize: "13px !important" }} />}
                            sx={{ bgcolor: "#E0F7FA", color: "#006D77", border: "1px solid #B2DFDB", fontSize: 11, "& .MuiChip-deleteIcon": { color: "#006D77" } }}
                          />
                        )}
                      </Box>
                      <Box sx={{
                        display: "grid",
                        gridTemplateColumns: { xs: "repeat(3, 1fr)", sm: "repeat(5, 1fr)", md: "repeat(7, 1fr)", lg: "repeat(9, 1fr)" },
                        gap: { xs: 1, sm: 1.5 },
                      }}>
                        {categories.map(({ name, count }) => (
                          <CategoryCard
                            key={name}
                            name={name}
                            count={count}
                            isActive={activeCategory === name}
                            onClick={() => {
                              setActiveCategory(activeCategory === name ? null : name);
                              setPage(1);
                            }}
                          />
                        ))}
                      </Box>
                    </Box>
                  )}

                  {/* Tests section */}
                  <Box sx={{ bgcolor: "#fff", borderRadius: 3, p: { xs: 2, md: 3 }, border: "1px solid #EEEEEE" }}>
                    {/* Header */}
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2.5 }}>
                      <Box>
                        <Typography fontWeight={800} fontSize={22} color="#1a1a1a">
                          {activeCategory || (search ? `Results for "${search}"` : "All Tests")}
                        </Typography>
                        
                      </Box>
                     {activeCategory !== "Packages" && (<Typography fontSize={12} color="#999" fontWeight={500}>
                        {totalTests} Items
                      </Typography>)}
                    </Box>
                     
  {
    activeCategory === "Packages" ? (
                      <>
                        {packages.length === 0 ? (
                          <Box textAlign="center" py={6}>
                            <Typography sx={{ fontSize: 48 }}>📦</Typography>
                            <Typography sx={{ fontSize: 15, fontWeight: 600, color: "#bbb", mt: 1.5 }}>
                              No packages available
                            </Typography>
                          </Box>
                        ) : (
                          <Box
                            sx={{
                              display: "grid",
                              gridTemplateColumns: {
                                xs: "1fr",
                                sm: "repeat(2,1fr)",
                                md: "repeat(3,1fr)",
                                lg: "repeat(4,1fr)",
                              },
                              gap: 1.5,
                            }}
                          >
                            {packages.map((pkg) => (
                              <Box key={pkg.id} sx={{ minWidth: 300, flexShrink: 0, }} > <PackageCard key={pkg.id} pkg={pkg} onBook={addToCart} onRemove={removeFromCart} isInCart={cartIds.has(getKey(pkg))}/> </Box>
                            ))}
                          </Box>
                        )}
                      </>
                    ) :
                     testsLoading ? (
                                        <Box display="flex" justifyContent="center" py={6}>
                                          <CircularProgress sx={{ color: C.primary }} />
                                        </Box>
                                      ) : 
                      tests.length === 0 ? (
                      <Box sx={{ textAlign: "center", py: 8 }}>
                        <ScienceIcon sx={{ fontSize: 56, color: "#E0E0E0", mb: 2 }} />
                        <Typography color="#bbb" fontSize={15} fontWeight={600}>No tests found</Typography>
                        <Typography color="#ccc" fontSize={12} mt={0.5}>Try a different search or category</Typography>
                      </Box>
                    ) : (
                      <Box sx={{
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(3, 1fr)", lg: "repeat(4, 1fr)" },
                        gap: 2,
                      }}>
                        {tests.map((test) => (
                          <TestCard
                            key={test.id}
                            test={test}
                            isInCart={cartIds.has(test.id)}
                            onAdd={addToCart}
                            onRemove={removeFromCart}
                          />
                        ))}
                      </Box>
                    )}
                  </Box>
                </>
              )}


            {totalPages > 1 && (
                          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                            <Pagination
                              count={totalPages} page={currentPage} onChange={handlePageChange}
                              color="primary"  
                              sx={{
                                '& .MuiPaginationItem-root': { fontSize: 16, fontWeight: 600 },
                                '& .Mui-selected': { bgcolor:  '#006D77 !important', color: '#fff', '&:hover': { bgcolor: '#005560 !important' } },
                              }}
                            />
                          </Box>
                        )}
            </>
          )}

          {/* ── STEP 2: CART ── */}
          {step === 2 && (
            <Box sx={{ bgcolor: "#fff", borderRadius: 3, p: { xs: 2, md: 3 }, border: "1px solid #EEEEEE" }}>
              <CartReview cart={cart} onRemove={removeFromCart} onContinue={() => setStep(3) } appliedPromo={appliedPromo} setAppliedPromo={setAppliedPromo}  />
            </Box>
          )}

          {/* ── STEP 3: BOOKING ── */}
          {step === 3 && (
            <Box sx={{ bgcolor: "#fff", borderRadius: 3, p: { xs: 2, md: 3 }, border: "1px solid #EEEEEE" }}>
              {/* Cart summary strip */}
              <Box sx={{
                display: "flex", alignItems: "center", justifyContent: "space-between",
                p: 2, mb: 3, borderRadius: 2.5,
                bgcolor: "#F0FFFE", border: "1.5px solid #B2DFDB",
              }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                  <Box sx={{ bgcolor: "#006D77", borderRadius: 1.5, p: 0.8 }}>
                    <ScienceIcon sx={{ color: "#fff", fontSize: 18 }} />
                  </Box>
                  <Box>
                    <Typography fontSize={13} fontWeight={700} color="#006D77">
                      {cart.length} Test{cart.length > 1 ? "s" : ""} Selected
                    </Typography>
                    <Typography fontSize={10} color="#888" noWrap sx={{ maxWidth: 200 }}>
                      {cart.slice(0, 2).map((t) => t.test_name).join(", ")}{cart.length > 2 ? ` +${cart.length - 2} more` : ""}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ textAlign: "right" }}>
                  <Typography fontSize={16} fontWeight={800} color="#006D77">₹{finalPayable.toFixed(2)}</Typography>
                  <Button size="small" onClick={() => setStep(2)}
                    sx={{ fontSize: 10, color: "#006D77", textTransform: "none", p: 0, minWidth: "auto", textDecoration: "underline" }}>
                    Edit Cart
                  </Button>
                </Box>
              </Box>

              <Typography fontWeight={800} fontSize={16} color="#1a1a1a" mb={2.5}>
                Patient Details & Appointment Time
              </Typography>

              {userLoading ? (
                <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
                  <CircularProgress sx={{ color: "#006D77" }} />
                </Box>
              ) : (
                <CommonFieldsScreen
                  userData={user}
                  serviceData={{
                    serviceTitle: "DIAGNOSTIC SAMPLE COLLECTION",
                    serviceImage: DiagnosticSample,
                    servicePrice: finalPayable,
                    orderType: "diagnostic",
                    diagnosticOrderData: {
                      tests: cart.map((t) => ({
                        test_id: t.id, test_code: t.test_code,
                        test_name: t.test_name, mrp: t.mrp,
                        proposed_rate: t.proposed_rate,
                        non_membership: t.non_membership,
                        category: t.category,
                      })),
                      total_amount: finalPayable,
                      mrp_total: calcMRP(),
                      savings: calcSavings(),
                      promo_discount: promoDiscount,
                      promo_code: appliedPromo?.code || null,
                    },
                  }}
                />
              )}
            </Box>
          )}
        </Container>
      </Box>
      

      {/* Floating cart */}
      {step === 1 && <CartBar cart={cart} onViewCart={() => setStep(2)} />}

      <Footer />
    </>
  );
};

export default DiagnosticDeliveryScreen;